import { render, staticRenderFns } from "./NextSectionButton.vue?vue&type=template&id=44aecec1"
import script from "./NextSectionButton.vue?vue&type=script&lang=js"
export * from "./NextSectionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports